<template>
  <div>
    <p class="headerstyle">เพิ่ม Banner</p>
    <div class="fromstyle">
      <form @submit.prevent="checkForm">
        <button
          class="my-5 uploadfield"
          @dragover.prevent
          @drop.prevent
          @click="onPickBannerImg"
          type="button"
        >
          <div
            @drop="dragBannerImg"
            class="flex items-center justify-center  h-full"
          >
            <img
              v-if="bannerImg"
              class="h-full w-full object-contain"
              :src="bannerImg.url"
            />
            <img
              v-show="!bannerImg"
              src="@/assets/images/elements/uploadbanner.svg"
            />
          </div>
        </button>
        <input
          type="file"
          accept="image/*"
          style="display: none"
          ref="BannerImgInput"
          @change="uploadBannerImg"
        />

        <div class="flex justify-center">
          <div class="w-3/5">
            <vs-input
              class="w-full mb-5"
              type="text"
              placeholder="ชื่อ Banner"
              v-model="banner_title"
              required
            />

            <vs-input
              class="w-full mb-5"
              type="text"
              placeholder="URL สำหรับการกด Banner"
              v-model="banner_href"
              required
            />
            <br />

            <div class="flex justify-center">
              <button class="share-btn" type="submit" value="Submit">
                บันทึก
              </button>
            </div>
          </div>
        </div>
        <p class="footer-text">
          Banner ที่บันทึกแล้ว จะอยู่ในประเภท “ยังไม่เผยแพร่” <br />
          สามารถเข้าไปปรับเปลี่ยนรูปแบบการเผยแพร่ได้หลังจากบันทึกแล้ว
        </p>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "../../../util/backend";
import normAxios from "axios";
import baseUrl from "../../../util/baseUrl";

export default {
  methods: {
    async checkForm(e) {
      //console.log(this.bannerImg);
      if (this.bannerImg) {
        this.$vs.loading();
        let config = {
          method: "post",
          url: `${baseUrl.baseurl()}/createBanner`,
          data: {
            title: this.banner_title.trimLeft(),
            url: this.bannerImg.url.trimLeft(),
            href: this.banner_href.trimLeft(),
            type: "image"
          }
        };
        axios
          .api(config)
          .then(res => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "การสร้าง Banner",
              text: "สำเร็จ",
              color: "success",
              icon: "check_box",
              position: "top-right"
            });
            this.$router.push({ path: "/banner" });
          })
          .catch(error => {
            this.$vs.notify({
              title: "Error message",
              text: `${
                error.response.data.error ? error.response.data.error : error
              }`,
              color: "danger",
              icon: "error",
              position: "top-right"
            });
            this.$vs.loading.close();
          });
      }

      this.errors = [];

      if (!this.bannerImg) {
        this.errors.push("กรุณาอัพโหลดภาพปก");
      }
    },

    //////Banner Image///////
    onPickBannerImg() {
      this.$refs.BannerImgInput.click();
    },
    async dragBannerImg(e) {
      console.log("file drag", e.dataTransfer.files[0]);
      this.bannerImg = await this.uploadFile(e.dataTransfer.files[0]);
    },
    async uploadBannerImg(e) {
      console.log("file click", e.target.files[0]);
      this.bannerImg = await this.uploadFile(e.target.files[0]);
    },

    async uploadFile(file) {
      let fd = new FormData();
      fd.append("file", file);
      fd.append("folder_id", 1);
      try {
        let res = await normAxios.post(
          "https://api.fastation.co.th/file/api/file/create",
          fd
        );
        //console.log(res.data);
        if (res.status == 200) {
          return res.data.data.uploadFileAtLevel;
        } else {
          alert(res.data.message);
        }
      } catch (error) {
        alert(error.response.data.message.toString());
      }
    }
  },

  data() {
    return {
      bannerImg: null,
      banner_title: null,
      banner_href: null
    };
  },
  computed: {
    ...mapGetters({})
  },

  components: {}
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.uploadbanner {
  height: 100px;
}
.fromstyle {
  padding: 0;
}

.share-btn {
  background-color: #0430ad;
  padding: 10px 20px 10px 20px;
  border-radius: 10px;
  border-style: none;
  color: #ffff;

  &:hover {
    transition-delay: 100ms;
    background-color: #072c49;
  }
  &:active {
    background-color: #072c49;
  }
}

.radiobanner {
  display: flex;
  justify-content: flex-start;
}
.radioitem {
  margin-right: 10px;
}
.fixtimepicker {
  z-index: 99;
}
.bannerimage {
  height: 250px;
  max-width: 100%;
}

.headerstyle {
  color: #1a3683;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
  text-align: center;
}

.upload-btn {
  border-radius: 10px;
  border-style: none;
  height: 42.5px;
}
.upload-btn-img {
  height: 42.5px;
}

.cus-select {
  font-size: 0.9rem !important;
  margin-bottom: 2rem;
}

.cus-select .multiselect__tags {
  font-size: 0.9rem !important;
  border: 2px solid #0430ad;
  color: rgba(4, 48, 173, 0.5);
}
</style>
